import { createContext } from 'react';

import { DataTableHookResult } from './hooks/index.js';
import { DataTableRow } from './DataTableTypes.js';

export type DataTableContextValue<
  TRow extends DataTableRow = DataTableRow,
  TContext = unknown
> = Omit<DataTableHookResult<TRow, TContext>, 'containerRef'>;

export const DataTableContext = createContext<DataTableContextValue | null>(null);
